import { MASK_BODY } from '../face-kit';
import { TAU, WHITE, paint, type Shape } from '../paint';

export const FINE = 3;
export const SIZE = 1.15;
export const WING_FRAMES = 3;
export const BELLY = { y: 0.8, lean: 2.2, gorged: 3.2 };

export function paintMosquitoes(): readonly Shape[] {
  return [0.2, 0.7, 1.2].map((beat) =>
    paint(14 * FINE, 14 * FINE, 4 * FINE, (ctx) => {
      ctx.scale(FINE, FINE);
      const wing = Math.sin(beat) * 3.2 + 0.5;
      ctx.beginPath();
      ctx.moveTo(-3.8, -wing);
      ctx.lineTo(0, 0);
      ctx.lineTo(3.8, -wing);
      ctx.lineCap = 'round';
      ctx.lineWidth = 1.3;
      ctx.strokeStyle = WHITE;
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(0, BELLY.y, BELLY.lean, 0, TAU);
      ctx.fillStyle = MASK_BODY;
      ctx.fill();
      ctx.lineWidth = 1.1;
      ctx.strokeStyle = WHITE;
      ctx.stroke();
    }),
  );
}
